import type * as ngRouter from '@uirouter/angularjs';
import * as angular from 'angular';

import { ReportViewDataService } from '../services';

class ReportLegacyVisualizationsExplore implements angular.IOnInit {
  static $inject = ['$state', 'ReportViewDataService'];

  owner: string;
  visualization: { id: string } = { id: '' };

  constructor(
    private $state: ngRouter.StateService,
    private reportViewData: ReportViewDataService
  ) {
    this.visualization.id = this.$state.params['vizId'];
  }

  $onInit(): void {}

  back() {
    const partialStateIfRunExist = this.reportViewData.getRunStateIfRunTokenExists();
    this.reportViewData.navigate({ ...partialStateIfRunExist, name: `${partialStateIfRunExist.name}.dashboard` });
  }
}

export const ID = 'reportLegacyVisualizationsExplore';

export const reportLegacyVisualizationsExplore: angular.IComponentOptions = {
  template: `
  <visualization-container
    visualization="ctrl.visualization"
    owner="ctrl.owner"
    on-dismiss="ctrl.back()"
  ></visualization-container>
  `,
  controller: ReportLegacyVisualizationsExplore,
  controllerAs: 'ctrl',
};
